/**
 * Global Style Constants for Exploros React Components
 * Based on assets/themes/exploros/scss/_variables.scss
 */

// Primary Colors
export const PRIMARY_MAIN = '#0090FA';
export const PRIMARY_LIGHT = '#4DB5FF';
export const PRIMARY_DARK = '#0073C7';

// Secondary Colors
export const SECONDARY_MAIN = '#0073C7';
export const SECONDARY_LIGHT = '#4D9EE0';
export const SECONDARY_DARK = '#001727';

// Contrast Colors
export const CONTRAST_TEXT = '#FFFFFF';

// Error Colors
export const ERROR_MAIN = '#FC0D1C';
export const ERROR_LIGHT = '#FFCCCC';

// Success Colors
export const SUCCESS_MAIN = '#19AC1D';
export const SUCCESS_LIGHT = '#DEF4E2';

// Warning Colors
export const WARNING_MAIN = '#FF9900';

// Gray Scale
export const MEDIUM_GRAY = '#E0E0E0';
export const ENDED_PROGRESS_GRAY = '#9E9E9E';
export const DESCRIPTION_GRAY = 'hsl(0,0%,33.5%)';
export const TEXT_LIGHT_GRAY = '#999999';
export const TEXT_DARK = '#333333';
export const TEXT_SECONDARY = 'rgba(0, 0, 0, 0.6)';

// Typography
export const FONT_FAMILY = 'Helvetica, Arial, sans-serif';
export const FONT_SIZE_BASE = 14;

// Font Weights
export const FONT_WEIGHT_LIGHT = 200;
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_MEDIUM = 500;
export const FONT_WEIGHT_BOLD = 700;

// Shape
export const BORDER_RADIUS = 4;
